


















import { defineComponent } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";

export default defineComponent({
  name: "CancelConfirm",
  components: { BaseConfirm, BaseButton },
  props: {
    value: { type: Boolean, required: true },
    title: { type: String, required: true },
    description: { type: String, required: true },
    canceling: { type: Boolean, required: true },
  },
});
